import usePmProvider from 'components/hooks/PM/usePmProvider';
import { PmViewConfigType } from './usePmViewer.types';
import { mapPmProviderToViewer } from './usePmViewer.utils';

const usePmViewer = () => {
  const pmProvider = usePmProvider();
  const pmProviderViewer: PmViewConfigType = mapPmProviderToViewer(pmProvider);

  return pmProviderViewer;
};

export default usePmViewer;
